import { t } from "i18next";
import style from "./Slide.module.scss";
import SlideWrapper from "./SlideWrapper";

interface PropisidProps {
  goBackHandler: () => void;
}
const Propisi = ({ goBackHandler }: PropisidProps) => {
  return (
    <SlideWrapper title={t("LOGIN.PROPISI")} goBackHandler={goBackHandler}>
      <p className={style.cardText}>{t("LOGIN.PROPISI_PARAGRAPH")}</p>
      <ul className={style.cardText}>
        <li>{t("LOGIN.PROPISI_LI_1")}</li>
        <li>{t("LOGIN.PROPISI_LI_2")}</li>
        <li>{t("LOGIN.PROPISI_LI_3")}</li>
      </ul>
    </SlideWrapper>
  );
};

export default Propisi;
